import { Col, Container, Row } from 'react-bootstrap'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './LabProducts.css'


const LabProducts = () => {
    return (
        <main className='labproducts'>
            <Container>
                <Row>
                    <h2>Nuestros servicios de Laboratorio</h2>
                    <Col md={12} className='my-4'>
                        <VerticalTimeline lineColor={ '#000' }>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Control continuo de ambientes para el buen funcionamiento del laboratorio</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Diseño, desarrollo y puesta en marcha de soluciones para los problemas inmediatos</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Gestión de soluciones generales para los trabajos continuos del laboratorio como Proyectos, Calibraciones, y suministtos de equipos</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Mantenimiento Normativo, Predictivo, Correctivo y Preventivo</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Desarrollo y actualización continua de la parte documental</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Asesoramiento continuo de actualizaciones Normativas</p>
                            </VerticalTimelineElement>
                        </VerticalTimeline>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default LabProducts